(ns frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.esg
  (:require
   [frontend.ui.component.lp-portal.column.pdf.view :refer [column]]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]))

(defn- esg-page-1
  [report-data]
  (let [{:keys [esg-targets-and-strategy-text incidents-text]} (:esg report-data)]
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Sustainability" :toc-item true})
     (column
      (card/card
       "Sustainability targets and strategy"
       (text-content/rich-content (:rich-content esg-targets-and-strategy-text)))
      (card/card-no-breaks-must-fit-on-1-page
       "Sustainability incidents"
       (text-content/rich-content (:rich-content incidents-text)))))))

(defn- esg-key-performance-indicators
  [esg]
  (let [key-perf-indicators (:figures esg)
        labels (cons nil (:column-order key-perf-indicators))
        rows (if (map? (:data key-perf-indicators)) ;;To make sure old data model still works
               (->> key-perf-indicators
                    :data
                    (mapv (fn [[row-label row-data]]
                            (cons row-label
                                  (->> (:column-order key-perf-indicators)
                                       (mapv (fn [k]
                                               (get row-data k))))))))
               (:data key-perf-indicators))
        data (cons labels rows)]
    (card/card
     "Key Performance Indicators"
     (table/raw-table data)
     (text-content/optional-footer esg {:margin-top 6}))))

(defn- esg-page-2
  [report-data]
  (when (->> report-data
             :esg
             :key-perf-indicators
             :figures
             :data
             (seq))
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Sustainability"})
     (column
      (esg-key-performance-indicators (-> report-data
                                          :esg
                                          :key-perf-indicators))))))

(defn esg-pages
  [report-data]
  (concat
   [(esg-page-1 report-data)
    (esg-page-2 report-data)]))
